var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useContext, useEffect, useRef } from "react";
import Socket, { generateRoomId } from "../providers/Socket";
let timer = 1000;
const useMain = () => {
    const { socket, addMessageToQueue } = useContext(Socket);
    const socketRef = useRef(socket);
    useEffect(() => {
        socketRef.current = socket;
    }, [socket]);
    const CreateRoomHandler = useCallback(function (config) {
        if (config.ownerId === config.userId)
            throw new Error("Invalid Config");
        const roomId = generateRoomId(config.postId, config.ownerId, config.userId);
        const currentTime = (new Date).getTime();
        return {
            oid: config.ownerId,
            pid: config.postId,
            post_country: config.post_country,
            post_img: config.post_img,
            post_title: config.post_title,
            unread: 0,
            rooms: [
                {
                    room: roomId,
                    uid: config.userId,
                    name: config.room.name,
                    avatar: config.room.avatar,
                    last_time: currentTime,
                    unread: 0
                }
            ],
        };
    }, [socket]);
    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    function waitForSocketConnection(resolveCallBack, rejectCallBack, numberOfTries) {
        return __awaiter(this, void 0, void 0, function* () {
            if (numberOfTries > 9)
                rejectCallBack();
            if (socketRef.current) {
                if (resolveCallBack)
                    resolveCallBack();
                return;
            }
            yield sleep(250);
            waitForSocketConnection(resolveCallBack, rejectCallBack, numberOfTries + 1);
        });
    }
    return {
        getUnreadPostRooms: useCallback((postId) => {
            return new Promise((resolve, reject) => {
                waitForSocketConnection(() => {
                    var _a;
                    if (socketRef.current && socketRef.current.connected) {
                        (_a = socketRef.current) === null || _a === void 0 ? void 0 : _a.emit('my-post-unread-rooms', { pid: postId }, function ({ result }) {
                            resolve(result);
                        });
                    }
                    else
                        reject('Socket is not connected');
                }, () => { reject('Socket does not exist'); }, 1);
            });
        }, [socket]),
        getBlockedUsers: useCallback(() => {
            return new Promise((resolve, reject) => {
                waitForSocketConnection(() => {
                    var _a;
                    if (socketRef.current && socketRef.current.connected) {
                        (_a = socketRef.current) === null || _a === void 0 ? void 0 : _a.emit('get-blocked', function (result) {
                            resolve(result);
                        });
                    }
                    else
                        reject('Socket is not connected');
                }, () => { reject('Socket does not exist'); }, 1);
            });
        }, [socket]),
        unblockUser: useCallback((memberId) => {
            return new Promise((resolve, reject) => {
                waitForSocketConnection(() => {
                    var _a;
                    if (socketRef.current && socketRef.current.connected) {
                        (_a = socketRef.current) === null || _a === void 0 ? void 0 : _a.emit('unblock-user', memberId);
                        resolve();
                    }
                    else
                        reject('Socket is not connected');
                }, () => { reject('Socket does not exist'); }, 1);
            });
        }, [socket]),
        createRoom: useCallback((config) => new Promise((resolve, reject) => {
            const intervalHandler = () => {
                const room = CreateRoomHandler(config);
                if (room) {
                    resolve(room);
                    clearInterval(interval);
                    return;
                }
                timer += 1000;
                if (timer > 10000) {
                    reject("Time Out");
                    clearInterval(interval);
                }
                return;
            };
            const interval = setInterval(intervalHandler, timer);
        }), [CreateRoomHandler]),
        sendMessageFromPlatform: useCallback((chatDetails) => {
            return new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
                addMessageToQueue(chatDetails);
                if (!socket)
                    reject('Chat is Not connected');
                resolve('Sending');
            }));
        }, [socket])
    };
};
export default useMain;
